import React, { useState, useEffect, useRef } from "react";
import ReactToPrint from "react-to-print";
import { Modal, ModalHeader, ModalBody, Button, Table } from "reactstrap";
import moment from "moment";
import * as Icons from "react-feather";
import { urlAPI, getUser, getToken } from "utility/Common";
import { handleActionLogout } from "redux/actions/auth/logoutActions";
import Axios from "axios";
import { useDispatch } from "react-redux";
import NumberFormat from "react-number-format";
import { Tab } from "bootstrap";

const headerStyle = {
  fontSize: "16px",
  color: "black",
  margin: "1px 1px 1px 1px",
};
const bodyStyle = {
  fontSize: "14px",
  color: "black",
  margin: "1px 1px 1px 1px",
};
const containerStyle = {
  padding: "1cm 1cm 1cm 1cm",
};
// const borderStyle = {
//   border: "2px solid black",
// };
// const borderTopNoneStyle = {
//   border: "2px solid black",
//   borderStyle: "none solid solid solid",
// };
// const borderBottomNoneStyle = {
//   border: "2px solid black",
//   borderStyle: "solid solid none solid",
// };
// const borderTopBottomNoneStyle = {
//   border: "2px solid black",
//   borderStyle: "none solid none solid",
// };

class ComponentToPrint extends React.Component {
  constructor(props) {
    super(props);
  }
  render() {
    const data = this.props.dataPrint;

    console.log("dataPrint", data);
    return (
      <div style={containerStyle}>
        <p style={{ ...headerStyle, textAlign: "center" }}>
          LAPORAN TERIMA BARANG
        </p>
        <p style={{ ...headerStyle, textAlign: "center" }}>
          UNIT GUDANG PENGADAAN
        </p>
        <p style={{ ...headerStyle, textAlign: "center" }}>
          RUMAH SAKIT PETROKIMIA GRESIK
        </p>
        <br />
        <Table borderless={true}>
          <tbody>
            <tr>
              <td style={{ width: "10%", verticalAlign: "top" }}>
                <p style={bodyStyle}>NO TB</p>
                <p style={bodyStyle}>TANGGAL</p>
              </td>
              <td style={{ width: "40%", verticalAlign: "top" }}>
                <p style={bodyStyle}>: {data?.NOTB}</p>
                <p style={bodyStyle}>
                  : {moment(data?.TANGGALTB).format("DD/MM/YYYY")}
                </p>
              </td>
              <td style={{ width: "10%", verticalAlign: "top" }}>
                <p style={bodyStyle}>NO PP</p>
                <p style={bodyStyle}>NO PO</p>
                <p style={bodyStyle}>DISTRIBUTOR</p>
              </td>
              <td style={{ width: "40%", verticalAlign: "top" }}>
                <p style={bodyStyle}>: {data?.NOPP}</p>
                <p style={bodyStyle}>: {data?.NOPO}</p>
                <p style={bodyStyle}>: {data?.NAMASUPPLIER}</p>
              </td>
            </tr>
          </tbody>
        </Table>
        <br />
        <Table bordered={true}>
          <thead>
            <tr>
              <th
                style={{
                  width: "5%",
                  verticalAlign: "top",
                  border: "1px solid black",
                }}
              >
                <p style={{ ...bodyStyle, textAlign: "center" }}>
                  <strong>NO</strong>
                </p>
              </th>
              <th
                style={{
                  width: "10%",
                  verticalAlign: "top",
                  border: "1px solid black",
                }}
              >
                <p style={{ ...bodyStyle, textAlign: "center" }}>
                  <strong>KODE</strong>
                </p>
              </th>

              <th
                style={{
                  width: "30%",
                  verticalAlign: "top",
                  border: "1px solid black",
                }}
              >
                <p style={{ ...bodyStyle, textAlign: "center" }}>
                  <strong>NAMA OBAT</strong>
                </p>
              </th>
              <th
                style={{
                  width: "5%",
                  verticalAlign: "top",
                  border: "1px solid black",
                }}
              >
                <p style={{ ...bodyStyle, textAlign: "center" }}>
                  <strong>JML</strong>
                </p>
              </th>
              <th
                style={{
                  width: "10%",
                  verticalAlign: "top",
                  border: "1px solid black",
                }}
              >
                <p style={{ ...bodyStyle, textAlign: "center" }}>
                  <strong>SATUAN</strong>
                </p>
              </th>
              <th
                style={{
                  width: "15%",
                  verticalAlign: "top",
                  border: "1px solid black",
                }}
              >
                <p style={{ ...bodyStyle, textAlign: "center" }}>
                  <strong>HARGA</strong>
                </p>
              </th>
              <th
                style={{
                  width: "10%",
                  verticalAlign: "top",
                  border: "1px solid black",
                }}
              >
                <p style={{ ...bodyStyle, textAlign: "center" }}>
                  <strong>DISC</strong>
                </p>
              </th>
              <th
                style={{
                  width: "15%",
                  verticalAlign: "top",
                  border: "1px solid black",
                }}
              >
                <p style={{ ...bodyStyle, textAlign: "center" }}>
                  <strong>TOTAL</strong>
                </p>
              </th>
            </tr>
          </thead>
          <tbody>
            {data?.DAFTARBARANG?.map((obj, index) => (
              <tr key={index}>
                <td style={{ textAlign: "center", border: "1px solid black" }}>
                  <p style={bodyStyle}>{index + 1}</p>
                </td>
                <td style={{ textAlign: "left", border: "1px solid black" }}>
                  <p style={bodyStyle}>
                    {obj?.ACCOUNT + "." + obj?.CC + "." + obj?.Kompilator}{" "}
                  </p>
                </td>
                <td style={{ textAlign: "left", border: "1px solid black" }}>
                  <p style={bodyStyle}>{obj?.NAMABARANG}</p>
                </td>
                <td style={{ textAlign: "center", border: "1px solid black" }}>
                  <p style={bodyStyle}>
                    <NumberFormat
                      value={Number(obj.JUMLAH)}
                      displayType={"text"}
                      decimalSeparator={","}
                      thousandSeparator={"."}
                      decimalScale={0}
                      fixedDecimalScale={true}
                    />
                  </p>
                </td>
                <td style={{ textAlign: "center", border: "1px solid black" }}>
                  <p style={bodyStyle}>{obj?.NAMASATUAN}</p>
                </td>
                <td style={{ textAlign: "right", border: "1px solid black" }}>
                  <p style={bodyStyle}>
                    <NumberFormat
                      value={Number(obj.HARGA)}
                      displayType={"text"}
                      decimalSeparator={","}
                      thousandSeparator={"."}
                      decimalScale={3}
                      fixedDecimalScale={true}
                    />
                  </p>
                </td>
                <td style={{ textAlign: "right", border: "1px solid black" }}>
                  <p style={bodyStyle}>
                    <NumberFormat
                      value={Number(obj.DISKON)}
                      displayType={"text"}
                      decimalSeparator={","}
                      thousandSeparator={"."}
                      decimalScale={5}
                      fixedDecimalScale={true}
                    />
                    %
                  </p>
                </td>
                <td style={{ textAlign: "right", border: "1px solid black" }}>
                  <p style={bodyStyle}>
                    <NumberFormat
                      value={Number(obj.HITUNGHARGADANDISKON)}
                      displayType={"text"}
                      decimalSeparator={","}
                      thousandSeparator={"."}
                      decimalScale={0}
                      fixedDecimalScale={true}
                    />
                  </p>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
        <br />
        <Table borderless={true}>
          <tbody>
            <tr>
              <td style={{ width: "15%", verticalAlign: "top" }}>
                <p style={bodyStyle}>JUMLAH HARGA</p>
                <p style={bodyStyle}>HARGA STLH DISC</p>
                <p style={bodyStyle}>PPn</p>
              </td>
              <td
                style={{
                  width: "15%",
                  verticalAlign: "top",
                  textAlign: "right",
                }}
              >
                <p style={bodyStyle}>
                  <NumberFormat
                    value={data?.DAFTARBARANG.reduce(
                      (a, b) => a + (b["HITUNGHARGA"] || 0),
                      0
                    )}
                    displayType={"text"}
                    decimalSeparator={","}
                    thousandSeparator={"."}
                    decimalScale={0}
                    fixedDecimalScale={true}
                  />
                </p>
                <p style={bodyStyle}>
                  <NumberFormat
                    value={data?.DAFTARBARANG.reduce(
                      (a, b) => a + (b["HITUNGHARGADANDISKON"] || 0),
                      0
                    )}
                    displayType={"text"}
                    decimalSeparator={","}
                    thousandSeparator={"."}
                    decimalScale={0}
                    fixedDecimalScale={true}
                  />
                </p>
                <p style={{ ...bodyStyle, borderBottom: "1px solid black" }}>
                  {data?.PPN?.trim() === "Y" ? (
                    <NumberFormat
                      value={
                        data?.DAFTARBARANG.reduce(
                          (a, b) => a + (b["HITUNGHARGADANDISKON"] || 0),
                          0
                        ) *
                        (Number(data?.NILAI_PPN) - 1)
                      }
                      displayType={"text"}
                      decimalSeparator={","}
                      thousandSeparator={"."}
                      decimalScale={0}
                      fixedDecimalScale={true}
                    />
                  ) : (
                    <>0</>
                  )}
                </p>
                <p style={bodyStyle}>
                  <NumberFormat
                    value={
                      data?.PPN?.trim() === "Y"
                        ? data?.DAFTARBARANG.reduce(
                            (a, b) => a + (b["HITUNGHARGA"] || 0),
                            0
                          ) -
                          data?.DAFTARBARANG.reduce(
                            (a, b) => a + (b["HITUNGDISKON"] || 0),
                            0
                          ) +
                          data?.DAFTARBARANG.reduce(
                            (a, b) => a + (b["HITUNGHARGADANDISKON"] || 0),
                            0
                          ) *
                            (Number(data?.NILAI_PPN) - 1)
                        : data?.DAFTARBARANG.reduce(
                            (a, b) => a + (b["HITUNGHARGADANDISKON"] || 0),
                            0
                          )
                    }
                    displayType={"text"}
                    decimalSeparator={","}
                    thousandSeparator={"."}
                    decimalScale={0}
                    fixedDecimalScale={true}
                  />
                </p>
              </td>
              <td
                style={{
                  width: "70%",
                  verticalAlign: "top",
                }}
              ></td>
            </tr>
          </tbody>
        </Table>
        <br />
        <Table borderless={true}>
          <tbody>
            <tr>
              <td
                style={{
                  width: "15%",
                  verticalAlign: "top",
                }}
              ></td>
              <td
                style={{
                  width: "25%",
                  verticalAlign: "top",
                }}
              >
                <p style={bodyStyle}>PENERIMA</p>
                <p style={bodyStyle}>{getUser()?.nama}</p>
              </td>
              <td
                style={{
                  width: "10%",
                  verticalAlign: "top",
                }}
              ></td>
              <td
                style={{
                  width: "30%",
                  verticalAlign: "top",
                  textAlign: "right",
                }}
              >
                <p style={bodyStyle}>GRESIK, {moment().format("DD/MM/YYYY")}</p>
              </td>
              <td
                style={{
                  width: "20%",
                  verticalAlign: "top",
                }}
              ></td>
            </tr>
          </tbody>
        </Table>
      </div>
    );
  }
}

export default function PrintComponent(props) {
  const { handleClose, open, notb } = props;
  const componentRef = useRef();
  const dispatch = useDispatch();
  const [dataPrint, setDataPrint] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (open) {
      fetchData();
    }
  }, [open]);

  const fetchData = () => {
    Axios.get(urlAPI + "/v1/inventory/NSIprinttb?notb=" + notb, {
      headers: {
        Authorization: "Bearer " + getToken(),
      },
    })
      .then((response) => {
        setDataPrint({
          rows: response?.data?.result?.rows?.map((obj) => ({
            ...obj,
            DAFTARBARANG: obj?.DAFTARBARANG?.map((objChild) => ({
              ...objChild,
              JUMLAH: Number(objChild?.JUMLAH),
              HARGA: Number(objChild?.HARGA),
              DISKON: Number(objChild?.DISKON),
              HITUNGDISKON:
                (Number(objChild?.JUMLAH) *
                  Number(objChild?.HARGA) *
                  Number(objChild?.DISKON)) /
                100,
              HITUNGHARGA: Number(objChild?.JUMLAH) * Number(objChild?.HARGA),
              HITUNGHARGADANDISKON:
                Number(objChild?.JUMLAH) * Number(objChild?.HARGA) -
                (Number(objChild?.JUMLAH) *
                  Number(objChild?.HARGA) *
                  Number(objChild?.DISKON)) /
                  100,
            })),
          })),
        });
        setLoading(false);
        // console.log(response?.data?.result?.rows[0]?.DAFTARBARANG[0]?.);
      })
      .catch((err) => {
        if (err.response?.statusText === "Unauthorized") {
          setLoading(false);
          dispatch(handleActionLogout());
        } else {
          dispatch({
            type: "FILL_GAGAL",
            gagal: true,
            pesan: err?.response?.data?.message,
          });
          setLoading(false);
        }
      });
  };

  const printStyle = `
 @media all {
  .page-break {
    display: none;
  }
}

@media print {
  html, body {
    height: initial !important;
    overflow: initial !important;
    -webkit-print-color-adjust: exact;
  }
}

@media print {
  .page-break {
    margin-top: 1rem;
    display: block;
    page-break-before: auto;
  }
}

@page {
  size: auto;
  margin: 20mm;
}
  `;
  console.log("dataPrint out", dataPrint);
  return (
    <Modal
      isOpen={open}
      toggle={handleClose}
      className="modal-dialog-centered modal-xl"
      backdrop="static"
    >
      <ModalHeader toggle={handleClose}>Print Preview</ModalHeader>
      <ModalBody>
        <ReactToPrint
          trigger={() => (
            <Button
              color="primary"
              // style={{ width: "200px" }}
              block
              disabled={loading}
              // size="sm"
            >
              <Icons.Printer size={14} /> Print
            </Button>
          )}
          content={() => componentRef.current}
          pageStyle={printStyle}
        />
        <hr />
        {loading ? (
          <div className="text-center">
            <h4>Loading...</h4>
          </div>
        ) : (
          <ComponentToPrint ref={componentRef} dataPrint={dataPrint?.rows[0]} />
        )}
      </ModalBody>
    </Modal>
  );
}
